// Phase 33.3 D-03b: a location she typed or dragged is never overwritten.
//
// When the desk re-runs the town lookup it offers a new venue location. The
// form may write it only while the field is empty, or still holds the last
// value the desk itself wrote. Pitfall P3: `userHasEdited` in EventFormVenue
// is also set by the town control, so it cannot tell a typed location from a
// town change; comparing with the last value the desk wrote can (typing and
// dragging the pin both change the field away from it).
//
// Kept separate from the town-change hook so Phase 33.1 reuses the hook
// without this guard. Pure: no React, no Supabase.

/** True when the desk may write its new value over `current`. */
export const mayDeskOverwrite = (
  current: string | null | undefined,
  lastDeskValue: string | null
): boolean =>
  (current ?? '').trim() === '' ||
  (lastDeskValue !== null && current === lastDeskValue)
